<template>
	<v-snackbar
		:visible.sync="showNotification"
		v-model="showNotification"
		:timeout="timeout"
		color="success"
	>
		{{ textSuccess }}

		<template v-slot:action="{ attrs }">
			<v-btn color="white" text v-bind="attrs" @click="handleClose()"> Close </v-btn>
		</template>
	</v-snackbar>
</template>

<script>
export default {
	name: 'PostReportNotification',
	props: {
		showNotification: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		handleClose() {
			this.$emit('update:showNotification', false)
		},
	},
	data() {
		return {
			textSuccess: 'Your report has been sent',
			textReject: 'Something went wrong',
			snackbar: false,
			timeout: 2000,
		}
	},
}
</script>

<style scoped></style>
